import React from 'react'

function BeLaunchifiedComponent() {
  return (
    <div>
      <h1>BE LAUNCHIFIED</h1>
    </div>
  )
}

export default BeLaunchifiedComponent
